<template>
  <div class="view-active-campaign">
    <div class="breadcrumbs d-flex align-items-center font-weight-bold mb-9">
      <router-link :to="{ name: 'home' }" class="text-secondary"
        >Início</router-link
      >
      <i class="icon-angle-right text-secondary mx-3"></i>
      <router-link :to="{ name: 'tools' }" class="text-secondary">
        Ferramentas
      </router-link>
      <i class="icon-angle-right text-secondary mx-3"></i>
      <router-link
        :to="{ name: 'tools-email-marketing' }"
        class="text-secondary"
      >
        E-mail marketing
      </router-link>
      <i class="icon-angle-right text-secondary mx-3"></i>
      Active Campaign
    </div>

    <h6 class="d-none d-lg-block">Active Campaign</h6>
    <div class="row align-items-center mb-5 pt-6">
      <div class="col-lg-3 mb-3">
        <div class="d-flex align-items-center">
          <div class="mr-5">Contas</div>
          <button
            class="btn btn-sm btn-outline-primary btn-square-sm p-5"
            @click="refresh"
          >
            <i class="icon-refresh-ccw" />
          </button>
        </div>
      </div>
      <div class="col-lg-9">
        <div class="d-flex algn-items-center justify-content-end">
          <search-filter
            class="mr-3 flex-fill"
            placeholder="Pesquisar conta"
            @search="searching"
            :showFilters="false"
            :showResultsDropdown="false"
          />
          <button
            type="button"
            class="btn btn-primary px-5 px-lg-6"
            @click="modal = true"
          >
            <span class="d-none d-lg-inline">
              Adicionar
            </span>
            <i class="icon-plus d-lg-none lead"></i>
          </button>
        </div>
      </div>
    </div>
    <div v-if="loading" class="text-center">
      <b-spinner variant="primary" />
    </div>
    <div v-else>
      <div
        v-if="!providers.length"
        class="container centralize-row text-center pt-5"
      >
        <div class="row justify-content-center">
          <div class="col-lg-5">
            <img
              class="d-block mb-9 mx-auto"
              src="@/assets/images/home/welcome.svg"
            />
            <h5>Você ainda não adicionou nenhuma conta</h5>
            <div class="text-secondary mb-5">
              Clique no botão acima para cadastrar
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <data-table
          class="d-none d-lg-block"
          :columns="columns"
          :data="providers"
          :firstColumnFr="3"
          :lastColumnFr="0.5"
        >
          <template #default="{ item }">
            <small class="d-flex align-items-center">
              {{ item.description }}
            </small>
            <small class="d-flex align-items-center">
              {{ mapProviderName[item.name] }}
            </small>
            <small
              class="d-flex align-items-center font-weight-bold text-success"
            >
              Ativo
            </small>
            <div class="d-flex align-items-center justify-content-end">
              <actions-dropdown
                :left="false"
                :right="true"
                :actions="actions"
                @delete="submitDelete(item)"
                @edit="edit(item)"
              />
            </div>
          </template>
        </data-table>
        <!-- mobile area -->
        <data-table
          class="d-lg-none"
          :columns="columns.slice(0, 2).map(() => '')"
          :data="providers"
          :firstColumnFr="3"
          :lastColumnFr="0.5"
        >
          <template #default="{ item }">
            <div class="d-flex flex-column text-left pl-3 py-5">
              <small class="d-flex align-items-center">
                <strong class="mr-3">Descrição:</strong>
                {{ item.description }}
              </small>
              <small class="d-flex align-items-center">
                <strong class="mr-3">Nome da conta:</strong>
                {{ mapProviderName[item.name] }}
              </small>
              <small
                class="d-flex align-items-center font-weight-bold text-success"
              >
                <strong class="mr-3 text-dark">Status:</strong>
                Ativo
              </small>
            </div>
            <div class="d-flex justify-content-end">
              <actions-dropdown
                :left="false"
                :right="true"
                :actions="actions"
                @delete="submitDelete(item)"
                @edit="edit(item)"
              />
            </div>
          </template>
        </data-table>
        <!-- mobile area -->
      </div>
      <div v-if="providers.length" class="d-flex justify-content-center">
        <paginator :pagination="pagination" @on-update="dispatch" />
      </div>
    </div>
    <active-campaign-modal
      v-model="modal"
      :editedProvider="editedProvider"
      @clear-edit="editedProvider = null"
      @refresh="refresh"
    />
  </div>
</template>
<script>
import ActiveCampaignModal from "@/components/tools/modals/ActiveCampaign";
import { mapState } from "vuex";

export default {
  components: {
    ActiveCampaignModal
  },
  data() {
    return {
      loading: false,
      editedProvider: null,
      modal: false,
      product_id: null,
      search: "",
      columns: ["Descrição", "Nome da conta", "Status", ""],
      actions: [
        {
          text: "Editar",
          class: "",
          icon: "fa-solid fa-pen",
          confirmation: {
            enable: false,
            text: ""
          },
          event: "edit"
        },
        {
          text: "Excluir",
          class: "text-danger",
          icon: "icon-trash",
          confirmation: {
            enable: true,
            text:
              "Deseja mesmo excluir esta integração? Não enviaremos mais os leads para esta segmentação."
          },
          event: "delete"
        }
      ]
    };
  },
  mounted() {
    this.dispatch();
  },
  computed: {
    ...mapState("product", ["products"]),
    ...mapState("integration", ["providers", "mapProviderName", "pagination"])
  },
  methods: {
    dispatch() {
      let params = {
        name: "active_campaign"
      };

      if (this.search) {
        params = { search: this.search };
      }

      this.loading = true;
      this.$store
        .dispatch("integration/getProviders", params)
        .catch(error => {
          this.$message.error("Não foi possível carregar as contas integradas");
        })
        .finally(() => {
          this.editedProvider = null;
          this.loading = false;
        });
    },
    searching(v) {
      this.search = v;
      this.dispatch();
    },
    submitDelete(v) {
      this.loading = true;
      this.$store
        .dispatch("integration/deleteProvider", v.id)
        .then(() => {
          this.dispatch();
          this.$message.success("Integração removida");
        })
        .catch(error => {
          if (error.response && error.response.data.detail) {
            this.$message.error(error.response.data.detail);
          } else {
            this.$message.error("Não foi possível deletar a conta integrada");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    edit(v) {
      this.editedProvider = v;
      this.modal = true;
    },
    refresh() {
      this.dispatch();
    }
  }
};
</script>
